import { Controller } from "@hotwired/stimulus"

// Drawer latéral listant les étudiants d'une promotion.
// Contenu chargé en Turbo Frame au click sur un bouton avatar-stack.
// RGAA 4.1 : focus trap + ESC + restauration du focus.
export default class extends Controller {
  static targets = ["drawer", "overlay", "frame"]

  static FOCUSABLE = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled]):not([type='hidden'])",
    "select:not([disabled])",
    "[tabindex]:not([tabindex='-1'])"
  ].join(",")

  connect() {
    this.isOpen = false
    this.previouslyFocused = null
    this.onKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  // Action: open({ params: { url, title } }) — chargé via data-students-drawer-url-param
  open(event) {
    event?.preventDefault()
    const url = event?.params?.url
    if (!url) return

    this.previouslyFocused = document.activeElement
    this.frameTarget.setAttribute("src", url)
    this.showShell()
    document.addEventListener("keydown", this.onKeydown)
    setTimeout(() => this.focusFirst(), 200)
  }

  close(event) {
    event?.preventDefault()
    if (!this.isOpen) return

    this.hideShell()
    document.removeEventListener("keydown", this.onKeydown)

    if (this.previouslyFocused) {
      this.previouslyFocused.focus()
      this.previouslyFocused = null
    }
  }

  showShell() {
    this.isOpen = true
    this.drawerTarget.classList.remove("translate-x-full")
    this.drawerTarget.setAttribute("aria-hidden", "false")
    this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.add("opacity-100")
    document.body.classList.add("overflow-hidden")
  }

  hideShell() {
    this.isOpen = false
    this.drawerTarget.classList.add("translate-x-full")
    this.drawerTarget.setAttribute("aria-hidden", "true")
    this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
    this.overlayTarget.classList.remove("opacity-100")
    document.body.classList.remove("overflow-hidden")
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      event.preventDefault()
      this.close()
      return
    }

    if (event.key !== "Tab") return

    const focusables = this.getFocusables()
    if (focusables.length === 0) return

    const first = focusables[0]
    const last = focusables[focusables.length - 1]

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  getFocusables() {
    return Array.from(this.drawerTarget.querySelectorAll(this.constructor.FOCUSABLE))
      .filter((el) => el.offsetWidth > 0 && el.offsetHeight > 0)
  }

  focusFirst() {
    const elements = this.getFocusables()
    if (elements.length > 0) elements[0].focus()
  }
}
